var $22339168a6e88f2f$exports = {};
$22339168a6e88f2f$exports = {
    "alert": `V\xfdstraha`,
    "dismiss": `Odstranit`
};


export {$22339168a6e88f2f$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
